import type { CSSProperties } from 'react';

const paths = {
    home: 'm3 10 9-7 9 7v10a1 1 0 0 1-1 1h-5v-7H9v7H4a1 1 0 0 1-1-1z',
    building: 'M4 21V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v17M16 9h3a1 1 0 0 1 1 1v11M2 21h20M8 7h1m3 0h1M8 11h1m3 0h1M8 15h1m3 0h1M9 21v-3h3v3',
    calendar: 'M8 2v4m8-4v4M3 10h18M4 4h16a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1Zm3 10h2m4 0h2m-8 4h2m4 0h2',
    reservations: 'M6 3h12a1 1 0 0 1 1 1v18l-3-2-4 2-4-2-3 2V4a1 1 0 0 1 1-1Zm2 5h8m-8 4h8m-8 4h5',
    partners: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2m20 0v-2a4 4 0 0 0-3-3.9M9 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm8 0a4 4 0 0 1 0 8',
    link: 'm10 13 4-4m-7 7-1 1a4.2 4.2 0 0 1-6-6l4-4a4.2 4.2 0 0 1 6 0m0 7a4.2 4.2 0 0 0 6 0l4-4a4.2 4.2 0 0 0-6-6l-1 1',
    chart: 'M3 3v18h18M7 16v-4m5 4V8m5 8V5',
    settings: 'm9 3-1 3-3 1-1 3 2 2-2 2 1 3 3 1 1 3h4l1-3 3-1 1-3-2-2 2-2-1-3-3-1-1-3ZM15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0',
    search: 'm21 21-5-5M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0',
    plus: 'M12 5v14M5 12h14',
    x: 'm6 6 12 12M6 18 18 6',
    left: 'm14 6-6 6 6 6',
    right: 'm10 6 6 6-6 6',
    down: 'm6 9 6 6 6-6',
    arrow: 'M4 12h16m-6-6 6 6-6 6',
    download: 'M12 3v12m-5-5 5 5 5-5M4 16v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4',
    sun: 'M12 2v2m0 16v2M2 12h2m16 0h2M5 5l1.5 1.5m11 11L19 19M5 19l1.5-1.5m11-11L19 5M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0',
    moon: 'M21 13A9 9 0 0 1 11 3 9 9 0 1 0 21 13Z',
    monitor: 'M3 3h18v14H3ZM8 21h8m-4-4v4',
    menu: 'M4 6h16M4 12h16M4 18h16',
    bell: 'M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9M10 21h4',
    refresh: 'M20 7v5h-5M4 17v-5h5M5 8a8 8 0 0 1 13-3l2 2M4 17l2 2a8 8 0 0 0 13-3',
    check: 'm5 12 4 4L19 6',
    'check-circle': 'M22 11a10 10 0 1 1-6-9M8 11l4 4L22 3',
    warning: 'm12 3 10 18H2L12 3Zm0 6v5m0 3v.1',
    info: 'M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0ZM12 11v6m0-10v.1',
    bed: 'M3 18V6m18 12v-8H3m0 5h18M7 7h4v3H7zM3 18v3m18-3v3',
    money: 'M3 5h18v14H3ZM15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0M6 12h.1m11.9 0h.1',
    clock: 'M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0ZM12 6v6l4 2',
    filter: 'M3 5h18M6 12h12M9 19h6',
    edit: 'm15 4 5 5M4 20l5-1L21 7a2 2 0 0 0-4-4L5 15l-1 5Z',
    copy: 'M8 8h12v13H8ZM16 8V3H3v13h5',
    globe: 'M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0ZM2 12h20M12 2c-6 5-6 15 0 20 6-5 6-15 0-20Z',
    shield: 'm12 2 9 4v6c0 5-9 10-9 10S3 17 3 12V6zM8 12l3 3 5-6',
    expand: 'M8 3H3v5m13-5h5v5M3 16v5h5m13-5v5h-5',
    collapse: 'M3 12h18M9 3v18',
    tag: 'M3 3h8l10 10-8 8L3 11zM7 7h.1',
    spark: 'm12 3 2.5 6.5L21 12l-6.5 2.5L12 21l-2.5-6.5L3 12l6.5-2.5z',
    logout: 'M9 3H3v18h6m5-14 5 5-5 5M7 12h12',
} as const;
export type IconName = keyof typeof paths;
export function Icon({ name, size = 20, className = '', style }: { name: IconName; size?: number; className?: string; style?: CSSProperties }) {
    return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" className={`icon ${className}`} style={style}><path d={paths[name]} /></svg>;
}
